import React, { Component, Fragment } from 'react';
import MaskedInput from 'react-maskedinput';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { Container } from './styles';

import Input from '../../components/Input';
import Loading from '../../components/Loading';

export default class Register extends Component {
  state = {
    alert: {},
    cpf: '',
    email: '',
    kind: 'personal',
    loading: false,
    name: '',
    password: '',
    phone: '',
    showAlert: false,
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {
      const {
        cnpj, cpf, email, kind, name, password, phone,
      } = this.state;

      await api.post('producers/create', {
        producer: {
          cnpj,
          cpf,
          email,
          kind,
          name,
          password,
          phone,
        },
      });

      this.props.history.push('/auth');
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangeMasked = (e) => {
    const formatedValue = e.target.value.replace(/\/|\.|-|_/g, '');
    this.setState({ [e.target.name]: formatedValue });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      cnpj,
      cpf,
      email,
      kind,
      loading,
      name,
      password,
      phone,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading && <Loading />}
        <Container>
          <div className="row">
            <div className="col-12">
              <h2>Criar conta</h2>
              <form onSubmit={this.handleSubmit}>
                <div className="radio-group">
                  <input
                    type="radio"
                    name="kind"
                    onChange={this.handleChange}
                    value="personal"
                    defaultChecked
                  />{' '}
                  Pessoa física
                  <br />
                  <input type="radio" name="kind" onChange={this.handleChange} value="company" />{' '}
                  Pessoa jurídica
                </div>
                <br />
                <Input
                  name="email"
                  value={email}
                  type="email"
                  placeholder="Email"
                  onChange={this.handleChange}
                />
                <Input
                  name="password"
                  value={password}
                  type="password"
                  placeholder="Senha"
                  onChange={this.handleChange}
                />
                <Input name="name" value={name} placeholder="Nome" onChange={this.handleChange} />
                <MaskedInput
                  mask="(11) 111111111"
                  name="phone"
                  onChange={this.handleChangeMasked}
                  placeholder="Celular"
                  value={phone}
                  className="masked-input"
                />
                {kind === 'personal' ? (
                  <MaskedInput
                    mask="111.111.111-11"
                    name="cpf"
                    onChange={this.handleChangeMasked}
                    placeholder="CPF"
                    value={cpf}
                    className="masked-input"
                  />
                ) : (
                  <MaskedInput
                    mask="11.111.111/1111-11"
                    name="cnpj"
                    onChange={this.handleChangeMasked}
                    placeholder="CNPJ"
                    value={cnpj}
                    className="masked-input"
                  />
                )}
                <input
                  type="submit"
                  style={{ width: '100%' }}
                  className="btn btn-primary"
                  value="Cadastrar"
                />
              </form>
              <p className="note">
                Já tem conta? <Link to="/auth">Faça login</Link>
              </p>
            </div>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/index.js